import PropTypes from 'prop-types';
import React from 'react';
import { Truck } from 'react-bootstrap-icons';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { newDate } from '../../../utils/formatters';

function ProductPOListSection({
	poList = [],
	source = '',
	theme,
	t,
	rowsPerPage,
	defaultDisplayRowCount,
	onToggleRows,
	onRowClick,
}) {
	const page = 0;
	const hasPOList = poList.length > 0;

	return (
		<>
			<Grid item xs={12} style={{ marginTop: theme.spacing(4) }}>
				<Grid container>
					<Grid item xs={12}>
						<Truck
							style={{
								fontSize: '1.45rem',
								marginBottom: '-.33rem',
								marginRight: '.49rem',
							}}
							aria-label="Truck"
							role="graphics-symbol"
							aria-hidden="true"
						/>
						<Typography
							variant="heading7"
							aria-label={t('containing_pos')}
							role="paragraph"
						>
							{t('containing_pos')}{' '}
							{poList.length > 0 ? `(${poList.length})` : ''}
						</Typography>
						<Divider
							sx={{ my: 1, position: 'relative', zIndex: 1 }}
							aria-label={t('containing_pos')}
							tabIndex={-1}
							role="presentation"
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Grid container>
					{hasPOList ? (
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={12}>
									<Grid container spacing={2}>
										<Grid
											item
											xs={12}
											style={{ marginTop: theme.spacing(-4.5) }}
										>
											<Paper
												sx={{
													width: '100%',
													maxWidth: {
														xs: '100%',
														sm: '100%',
														md: `calc(100vw - 21.75rem)`,
														boxShadow: 'none',
													},
													overflow: 'hidden',
													display: 'flex',
													flexDirection: 'column',
													marginTop: '1.5rem',
												}}
											>
												<TableContainer>
													<Table aria-label="po table" sx={{ width: '100%' }}>
														<TableHead>
															<TableRow>
																<TableCell
																	component="th"
																	scope="col"
																	sx={{
																		minWidth: '8.75rem',
																		lineHeight: '1.25rem',
																		width: 'auto',
																		maxWidth: '12.5rem',
																		paddingLeft: '0',
																	}}
																>
																	<Typography variant="tableHeader">
																		{t('po_number')}
																	</Typography>
																</TableCell>
																<TableCell
																	component="th"
																	scope="col"
																	sx={{
																		minWidth: '8.75rem',
																		lineHeight: '1.25rem',
																		width: 'auto',
																		maxWidth: '12.5rem',
																		paddingLeft: '0',
																	}}
																>
																	<Typography variant="tableHeader">
																		{t('order_date')}
																	</Typography>
																</TableCell>
																<TableCell
																	component="th"
																	scope="col"
																	sx={{
																		minWidth: '8.75rem',
																		lineHeight: '1.25rem',
																		width: 'auto',
																		maxWidth: '12.5rem',
																		paddingLeft: '0',
																	}}
																>
																	<Typography variant="tableHeader">
																		{t('po_customer_item_number')}
																	</Typography>
																</TableCell>
																<TableCell
																	component="th"
																	scope="col"
																	sx={{
																		minWidth: '8.75rem',
																		lineHeight: '1.25rem',
																		width: 'auto',
																		maxWidth: '12.5rem',
																		paddingLeft: '0',
																	}}
																>
																	<Typography variant="tableHeader">
																		{t('qty_ordered')}
																	</Typography>
																</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															{poList
																.slice(
																	page * rowsPerPage,
																	page * rowsPerPage + rowsPerPage
																)
																.map((row, index) => (
																	<TableRow
																		aria-label="orders"
																		role="row"
																		hover
																		key={row.Order_Number}
																		onClick={() =>
																			onRowClick(
																				poList[index].Order_Number,
																				source
																			)
																		}
																		style={{ cursor: 'pointer' }}
																	>
																		<TableCell
																			role="cell"
																			style={{ paddingLeft: '0' }}
																		>
																			<Typography
																				variant="tableCell"
																				color="textSecondary"
																			>
																				{row.PO}
																			</Typography>
																		</TableCell>
																		<TableCell
																			role="cell"
																			style={{ paddingLeft: '0' }}
																		>
																			<Typography
																				variant="tableCell"
																				color="textSecondary"
																			>
																				{newDate(row.Order_Date)}
																			</Typography>
																		</TableCell>
																		<TableCell
																			role="cell"
																			style={{ paddingLeft: '0' }}
																		>
																			<Typography
																				variant="tableCell"
																				color="textSecondary"
																			>
																				{row.Customer_Item_Number}
																			</Typography>
																		</TableCell>
																		<TableCell
																			role="cell"
																			style={{ paddingLeft: '0' }}
																		>
																			<Typography
																				variant="tableCell"
																				color="textSecondary"
																			>
																				{row.Quantity_Ordered}
																			</Typography>
																		</TableCell>
																	</TableRow>
																))}
														</TableBody>
													</Table>
												</TableContainer>
											</Paper>
										</Grid>
										{poList.length > defaultDisplayRowCount && (
											<Grid item xs={12}>
												<Box textAlign="center" alignItems="center">
													<Button
														variant="outlined"
														color="primary"
														size="large"
														role="button"
														data-testid={t('return_home')}
														aria-label={t('return_home')}
														aria-pressed="false"
														tabindex="0"
														onClick={onToggleRows}
													>
														{rowsPerPage === defaultDisplayRowCount
															? t('show_all')
															: t('show_less')}
													</Button>
												</Box>
											</Grid>
										)}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					) : (
						<Grid item xs={12}>
							<Typography variant="caption" color="textSecondary">
								{t('no_pos_for_product')}
							</Typography>
						</Grid>
					)}
				</Grid>
			</Grid>
		</>
	);
}

ProductPOListSection.propTypes = {
	defaultDisplayRowCount: PropTypes.number.isRequired,
	onRowClick: PropTypes.func.isRequired,
	onToggleRows: PropTypes.func.isRequired,
	poList: PropTypes.arrayOf(PropTypes.object),
	rowsPerPage: PropTypes.number.isRequired,
	source: PropTypes.string,
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default ProductPOListSection;
